<div class="">
    <div class="row">
        <div class="col-sm-12">
            <button class="btn pull-right m-2" style="background-color: #6e7dd2; color:#fff" (click)="exportAsExcel()">
                Download CSV
            </button>
        </div>
    </div>
<mat-card class="filter col-lg-9 px-0 py-1" style="margin-top: 10px;">
    <mat-card-content>
        <div class="row">
            <div class="col-sm-12">
                <button 
                *ngFor="let filter of ['Today', 'Week', 'MTD', 'YTD', 'Custom Date']" 
                type="button" 
                mat-raised-button 
                class="btn m-1" 
                [ngClass]="{
                  'btn-secondary': dateType === filter, 
                  'btn-outline-secondary': dateType !== filter
                }"
                (click)="filter === 'Custom Date' ? toggleCustomDate() : setDateFilter(filter)">
                {{ filter === 'Week' ? 'Last 7 days' : filter }}
              </button>
            </div>
        </div>
        <div class="row col-sm-12 m-2 mb-3" *ngIf="showCustomDate">
            <div class="col-lg-5 m-0 p-0">
                <div class="col-sm-2 newMarginClass">From:</div>
                <div class="col-sm-8">
                    <div class="input-icon right" mat-menu-item>
                        <input
                        type="date"
                        [(ngModel)]="fromDate"
                        placeholder="MM/DD/YYYY"
                        class="form-control"
                        style="width: 300px"
                        [min]="today1"
                        id="fromDate"
                      >
                      
                    </div>
                </div>
            </div>
            <div class="col-lg-5 m-0 p-0">
                <div class="col-sm-2 newMarginClass">To:</div>
                <div class="col-sm-8">
                    <div class="input-icon right" mat-menu-item>
                        <input
                        type="date"
                        [(ngModel)]="toDate"
                        placeholder="MM/DD/YYYY"
                        class="form-control"
                        style="width: 300px"
                        [min]="today1"
                        id="toDate"
                      >
                    </div>
                </div>
            </div>
            <div class="col-lg-1 p-0 m-0">
                <button mat-raised-button class="btn btn-success pull-right mr-2 fa fa-search" style="background-color: #6e7dd2; color:#fff;" (click)="applyFilters()">Search</button>
            </div>
            <div class="col-lg-1 p-0 m-0">
                <button mat-raised-button class="btn filter-hover fa fa-eraser" style="background-color: #37474f; color: #fff !important;" (click)="clearFilters()">Clear</button>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<div class="row mt-2">
    <div class="col-11 ml-1">
        <div widget class="card border-0 box-shadow">
            <div class="card-body widget-body">
                <div class="row form-inline">
                    <div class="form-group col-xl-1 col-sm-6 col-12" style="color: black">Filter By:</div>
                    <div class="form-group col-xl-2 col-sm-6 col-12">
                        <mat-select [(ngModel)]="selectedFilter" (selectionChange)="onFilterChange($event)" placeholder="Filter by" style="width: 100%; border: 1px solid black" class="form-control">
                            <mat-option value="any">Any</mat-option>
                            <mat-option value="booking_id">Booking ID</mat-option>
                            <mat-option value="order_id">Order ID</mat-option>
                            <mat-option value="vehicle_number">Vehicle Number</mat-option>
                            <!-- <mat-option value="status">Status</mat-option> -->
                        </mat-select>
                    </div>
                    <div class="col-sm-3">
                        <div class="row">
                            <div class="col-sm-3 form-group" style="color: black">Keyword:</div>
                            <div class="col-sm-9">
                                <input [(ngModel)]="keyword" style="width: 90%; border: 1px solid black" type="text" class="form-control" placeholder="Search by Keyword" />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedFilter === 'status'" class="col-sm-3">
                        <div class="row">
                            <div class="col-sm-3 form-group" style="color: black">Status:</div>
                            <div class="col-sm-9">
                                <mat-select [(ngModel)]="selectedStatus" style="width: 100%; border: 1px solid black" class="form-control">
                                    <mat-option value="Confirmed">Confirmed</mat-option>
                                    <mat-option value="Provisional">Provisional</mat-option>
                                </mat-select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-sm-3">
                        <button (click)="applyFilters()" class="btn btn-primary fa fa-search"><span> Search</span></button>
                        <button (click)="clearFilters()" class="btn btn-danger fa fa-eraser" style="margin-left: 10px"><span> Clear</span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div style="overflow-x: auto; width: 100%;">
    <table class="table table-hover text-center table-bordered" style="table-layout: auto; width: 100%;">
        <thead class="tbl-head" style="height: 45px;">
            <tr class="tr-grid-header m-0 p-0" style="background: rgb(62, 67, 147);">
                <th style="color: white; white-space: nowrap; padding: 0 10px;" scope="col">Booking ID</th>
                <th style="color: white; white-space: nowrap; padding: 0 10px;" scope="col">Customer Name</th>
                <th style="color: white; white-space: nowrap; padding: 0 10px;" scope="col">Order ID</th>
                <th style="color: white; white-space: nowrap; padding: 0 10px;" scope="col">Service Type</th>
                <th style="color: white; white-space: nowrap; padding: 0 10px;" scope="col">Origin</th>
                <th style="color: white; white-space: nowrap; padding: 0 10px;" scope="col">Via 1</th>
                <th style="color: white; white-space: nowrap; padding: 0 10px;" scope="col">Via 2</th>
                <th style="color: white; white-space: nowrap; padding: 0 10px;" scope="col">Destination</th>
                <th style="color: white; white-space: nowrap; padding: 0 10px;" scope="col">Vehicle No.</th>
                <th style="color: white; white-space: nowrap; padding: 0 10px;" scope="col">Placement Date</th>
                <th style="color: white; white-space: nowrap; padding: 0 10px;" scope="col">Freight</th>
                <th style="color: white; white-space: nowrap; padding: 0 10px;" scope="col">Status</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngIf="orders.length === 0">
                <td colspan="11" style="text-align: center; color: black; padding: 20px;"><strong>No records available</strong></td>
            </tr>
            <ng-container *ngFor="let order of orders">
                <tr style="height: 40px; background: white;" *ngIf="order.StatusOfOrder === 'Confirmed' || order.StatusOfOrder === 'Provisional'">
                    <td style="border: 3px solid #dee2e6;">{{ order.BookingIdCode || '-' }}</td>
                    <td style="border: 3px solid #dee2e6;">{{ order.CustomerNameFull || '-' }}</td>
                    <td style="border: 3px solid #dee2e6;">{{ order.OrderIdCode || '-' }}</td>
                    <td style="border: 3px solid #dee2e6;">{{ order.ServiceType || '-' }}</td>
                    <td style="border: 3px solid #dee2e6;">{{ order.Origin || '-' }}</td>
                    <td style="border: 3px solid #dee2e6;">{{ order.Via1 || '-' }}</td>
                    <td style="border: 3px solid #dee2e6;">{{ order.Via2 || '-' }}</td>
                    <td style="border: 3px solid #dee2e6;">{{ order.Destination || '-' }}</td>
                    <td style="border: 3px solid #dee2e6;">
                        <a (click)="openMap(order)" style="cursor: pointer; color: #007bff;">
                          {{ order.VehicleNo || '-' }}
                        </a>
                      </td>                                           
                    <td style="border: 3px solid #dee2e6;">{{ formatDate(order.ToPlacementTime) || '-' }}</td>
                    <td style="border: 3px solid #dee2e6;">{{ order.Freight || '-' }}</td>
                    <td style="border: 3px solid #dee2e6;">{{ order.StatusOfOrder || '-' }}</td>
                </tr>
            </ng-container>
        </tbody>
    </table>
    <mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]" (page)="onPageChange($event)" showFirstLastButtons></mat-paginator>
</div>
</div>